import {
	Box,
	TableCell,
	TableHead,
	TableRow,
	TableSortLabel,
} from "@mui/material";
import { visuallyHidden } from "@mui/utils";

import { sortDate } from "../../../utils/sort-methods";

import Heading5 from "../../typography/heading-05";

import styles from "./index.module.scss";

import "./mui-styles.scss";

const TableHeadMessages = (props) => {
	const {
		data,
		// sort
		order,
		orderBy,
		onRequestSort,
		rowData,
		setSortedData,
	} = props;

	const createSortHandler = (property) => (event) => {
		// Only allow sorting on date fields
		if (!property.includes("date") && !property.includes("datetime")) {
			return;
		}

		let fieldId;

		// Map only date column IDs to message object properties
		if (property === "date-created") {
			fieldId = "created_at";
		} else if (property === "start-datetime") {
			fieldId = "start_date";
		} else if (property === "end-datetime") {
			fieldId = "end_date";
		}

		// Apply date sorting for date fields only
		let sortedData = sortDate(rowData, order, fieldId);

		setSortedData(sortedData);
		onRequestSort(event, property);
	};

	return (
		<TableHead>
			<TableRow>
				{/* No checkbox column as per design requirements */}
				{data.map((headCell) => {
					const isDateField =
						headCell.id.includes("date") || headCell.id.includes("datetime");

					return (
						<TableCell
							key={headCell.id}
							align={headCell.numeric ? "right" : "left"}
							padding={headCell.disablePadding ? "none" : "normal"}
							sortDirection={orderBy === headCell.id ? order : false}
							style={{ minWidth: headCell.minWidth }}
						>
							{isDateField ? (
								<TableSortLabel
									active={orderBy === headCell.id}
									direction={orderBy === headCell.id ? order : "asc"}
									onClick={createSortHandler(headCell.id)}
								>
									<Heading5
										text={headCell.label}
										extraClass={styles.thText}
										fontType="semibold"
									/>
									{orderBy === headCell.id ? (
										<Box component="span" sx={visuallyHidden}>
											{order === "desc"
												? "sorted descending"
												: "sorted ascending"}
										</Box>
									) : null}
								</TableSortLabel>
							) : (
								<Heading5
									text={headCell.label}
									extraClass={styles.thText}
									fontType="semibold"
								/>
							)}
						</TableCell>
					);
				})}
			</TableRow>
		</TableHead>
	);
};

export default TableHeadMessages;
